import {
  GET_HOME_OVERVIEW,
  GET_HOME_RECENT_JOBS,
  GET_HOME_RECENT_DEVICES,
  GET_JOB_DETAILS
} from '../reducers/homeReducer'
import type { ReduxAxiosAction } from './common'

export const HOME_LOAD_FAIL_TOAST = 'error_loading_home'

export const getHomeOverview = (): ReduxAxiosAction => {
  return {
    type: GET_HOME_OVERVIEW,
    payload: {
      request: {
        mode: 'no-cors',
        url: 'home/overview',
        method: 'GET'
      }
    }
  }
}

export const getHomeRecentJobs = (limit: number = 10, pageNumber: number = 1, search: string = ''): ReduxAxiosAction => {
  const searchQuery = search && search.trim() ? `&search=${encodeURIComponent(search.trim())}` : ''

  return {
    type: GET_HOME_RECENT_JOBS,
    payload: {
      request: {
        mode: 'no-cors',
        url: `home/recent-jobs?limit=${limit}&pageNumber=${pageNumber}${searchQuery}`,
        method: 'GET'
      }
    }
  }
}

export const getHomeRecentDevices = (limit: number = 10, pageNumber: number = 1, search: string = ''): ReduxAxiosAction => {
  const searchQuery = search && search.trim() ? `&search=${encodeURIComponent(search.trim())}` : ''

  return {
    type: GET_HOME_RECENT_DEVICES,
    payload: {
      request: {
        mode: 'no-cors',
        url: `home/devices?limit=${limit}&pageNumber=${pageNumber}${searchQuery}`,
        method: 'GET'
      }
    }
  }
}

export const getJobDetails = (jobId: string | number): ReduxAxiosAction => {
  return {
    type: GET_JOB_DETAILS,
    payload: {
      request: {
        mode: 'no-cors',
        url: `home/job-details/${jobId}`,
        method: 'GET'
      }
    }
  }
}
